// Reducer for chat actions
import { RECEIVE_CHAT, RECEIVE_THREAD, REQUEST_CHAT, REQUEST_CHAT_FAILURE, REQUEST_THREAD, REQUEST_THREAD_FAILURE } from '../constants/action_types'
import { LS_OPENAI_TOKEN_ID } from '../constants/local_storage'

const initialState = {
  threadId: '',
  messages: [],
  threadError: '',
  chatError: ''
}


export const chat = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_THREAD:
      return {
        ...state,
        threadId: action.payload,
        messages: [],
        error: '',
        isFetching: true
      }
    case RECEIVE_THREAD:
      localStorage.setItem(LS_OPENAI_TOKEN_ID, JSON.stringify(action.response.thread_id))
      return {
        ...state,
        threadId: action.response.thread_id,
        isFetching: false
      }
    case REQUEST_THREAD_FAILURE:
      return {
        ...state,
        threadError: action.error,
        isFetching: false
      }
    case REQUEST_CHAT:
      return {
        ...state,
        messages: [...state.messages, { text: action.message, sender: 'user' }],
        isFetching: true
      }
    case RECEIVE_CHAT:
      return {
        ...state,
        messages: [...state.messages, { text: action.response.response, sender: 'bot' }],
        isFetching: false
      }
    case REQUEST_CHAT_FAILURE:
      return {
        ...state,
        chatError: action.error,
        isFetching: false
      }
    default:
      return state
  }
}